import BaseContainer from "@components/ui/BaseContainer";
import useProjectContext from "@utils/hooks/context/useProjectContext";
import useDynamicImage from "@utils/hooks/ui/useDynamicImage";
import classes from "./Intro.module.scss";

const Intro = () => {
  const { project } = useProjectContext();

  const { src } = useDynamicImage(`projects/${project.id}/intro.png`);

  return (
    <BaseContainer className={classes.intro}>
      <div className={classes.intro__headings}>
        <h2 className={classes.intro__title}>{project.intro.title}</h2>
        <p className={classes.intro__subtitle}>{project.intro.subtitle}</p>
      </div>
      <img className={classes.intro__img} src={src} alt="" />
    </BaseContainer>
  );
};

export default Intro;
